module.exports = "/_next/static/images/1bbdd6604f448d25b795f7568861cd6d-website-thumb.jpg";